module.exports = __webpack_public_path__ + "img/icon_crop.e10046a2.png";